"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equalWith = void 0;
function equalWith(value, options, params) {
    var valueToCompare;
    var errors;
    if (options === null || options === void 0 ? void 0 : options.property) {
        valueToCompare = params === null || params === void 0 ? void 0 : params.entity[options.property];
        errors = {
            params: [options.property],
        };
    }
    else if (options === null || options === void 0 ? void 0 : options.value) {
        valueToCompare = options.value;
        errors = {
            params: [options.value],
        };
    }
    else {
        throw new Error("You have to compare with an objects property or specific value");
    }
    var isValid = value === valueToCompare;
    return {
        isValid: isValid,
        errors: errors,
    };
}
exports.equalWith = equalWith;
